import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { submitFormCapital, setToReducer, pageRequest } from 'actions/capital';
import {
  CAPITAL_INTRO_PAGE,
  CAPITAL_ALLOW_PERMISSION_PAGE,
  CAPITAL_DENIED_PERMISSION_PAGE,
  CAPITAL_DASHBOARD_PAGE,
  CAPITAL_FORM_APPLICATION_PAGE,
  CAPITAL_INCOMPLETE_PROFILE_PAGE,
} from 'utils/capitalUtils';
import { BUSINESS_TYPES, BUSINESS_CATEGORIES_ALL } from 'api/constants';
import {
  isMobileDevice,
  setResponsiveMode,
  setFullSiteMeta,
} from 'utils/fullSite';
import { browserHistory } from 'react-router';
import {
  mWebCapitalStart as mWebCapitalStartClevertap,
  mWebCapitalCta as mWebCapitalCtaClevertap,
} from 'clevertap/mWebFullSiteSwitch';
import * as actNotification from 'actions/notifications';
import welcomeImage from './images/capital_landing_img.png';
import Introduction from './Introduction';
import PermissionSharing from './PermissionSharing';
import IncompleteProfile from './IncompleteProfile';
import PermissionDenied from './PermissionDenied';
import DashboardRevamp from './DashboardRevamp';
import styles from './Capital.css';

function MobileLandingPage(props) {
  return (
    <div className={styles.container}>
      <img src={welcomeImage} className={styles.welcomeImage} />
      <div className={styles.text}>
        <b className={styles.title}>Moka Capital</b>
        <br />A convenient funding solution for your business needs. Simple
        requirements, minimum documents needed, secure process, and
        collateral-free.
      </div>
      <button
        className={`btn btn-primary ${styles.button}`}
        onClick={props.onClickSwitchButton}
      >
        Apply Now
      </button>
    </div>
  );
}

class Capital extends Component {
  handleSwitchToFullSite = () => {
    // Disable responsive view
    setFullSiteMeta();

    // To keep user in full site mode when refreshing page
    setResponsiveMode(false);

    // Redirect to default landing page
    browserHistory.push('/capital');

    mWebCapitalCtaClevertap();
  };

  componentDidMount() {
    this.props.dispatch(pageRequest());
    if (isMobileDevice()) {
      mWebCapitalStartClevertap();
    }
    // GETTING BUSINESS TYPE AND BUSINESS CATEGORY
    Promise.all([axios.get(BUSINESS_TYPES), axios.get(BUSINESS_CATEGORIES_ALL)])
      .then(res => [res[0], res[1]])
      .then(([businessType, businessCategory]) => {
        const { dispatch } = this.props;
        dispatch(setToReducer('businessCategory', businessCategory.data));
        dispatch(setToReducer('businessType', businessType.data));
      })
      .catch(() =>
        this.props.dispatch(
          actNotification.error(
            'Failed to Get business type or business Category'
          )
        )
      );
  }

  render() {
    const { showLoadingSpinnerPage, capitalPage, applicationPage } = this.props;

    if (isMobileDevice()) {
      return (
        <MobileLandingPage onClickSwitchButton={this.handleSwitchToFullSite} />
      );
    }

    return (
      <div>
        <div className={styles['loading-plan']}>
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            loadingDescription={
              capitalPage === CAPITAL_FORM_APPLICATION_PAGE &&
              applicationPage === 1
                ? "Please wait, we're preparing your data..."
                : ''
            }
          />
        </div>
        {!showLoadingSpinnerPage && (
          <div className={`col-md-12 ${styles['box-content']}`}>
            {capitalPage === CAPITAL_INTRO_PAGE && <Introduction />}
            {capitalPage === CAPITAL_ALLOW_PERMISSION_PAGE && (
              <PermissionSharing />
            )}
            {capitalPage === CAPITAL_INCOMPLETE_PROFILE_PAGE && (
              <IncompleteProfile />
            )}
            {capitalPage === CAPITAL_DENIED_PERMISSION_PAGE && (
              <PermissionDenied />
            )}
            {capitalPage === CAPITAL_FORM_APPLICATION_PAGE ||
              (capitalPage === CAPITAL_DASHBOARD_PAGE && <DashboardRevamp />)}
          </div>
        )}
      </div>
    );
  }

  handleSubmit = values => {
    const { businessType, businessCategory } = this.props;
    this.props.dispatch(
      submitFormCapital({ ...values, businessType, businessCategory })
    );
  };
}

function mapStateToProps(state) {
  const {
    capital: { applicationPage, capitalPage, businessType, businessCategory },
    loadingSpinner: { showLoadingSpinnerPage },
  } = state;

  return {
    capitalPage,
    showLoadingSpinnerPage,
    applicationPage,
    businessCategory,
    businessType,
  };
}

export default connect(mapStateToProps)(Capital);
